const CheckboxCheckedIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='19' height='19' rx='5.5' fill='#402080' stroke='#402080' />
      <g clipPath='url(#clip0_20320_158694)'>
        <path d='M4 9.5L8 13.5L16 6' stroke='white' strokeWidth='1.5' />
      </g>
      <defs>
        <clipPath id='clip0_20320_158694'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
export default CheckboxCheckedIcon
